import { auth } from './firebase';

export const fetcher: typeof fetch = async (input, init) => {
  const token = await auth.currentUser?.getIdToken();

  return fetch(`${import.meta.env.VITE_API_URL}${input}`, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    ...init,
  });
};
